import React from "react";
import {
  Box,
  Grid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import NavCard from "../../../../components/navcard";
import NavigationTabs from "../../../../components/tab";
import useQualityimprovementTabs from "../../../../utils/data/QiTabs";
import useQIProjectMenuItems from "../../../../utils/data/QIProjectMenuItems";
import Title from "../../../../components/Title";

const QIProject = () => {
  const Menu = useQIProjectMenuItems();
  const QiTabs = useQualityimprovementTabs();
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      w={"100%"}
      h={"100%"}
      flexDirection={"column"}
      justifyContent={"flex-start"}
      alignItems={"center"}
      alignContent={"flex-start"}
      textAlign={"left"}
    >
      <Grid
        w={"70%"}
        templateColumns={["repeat(1, 1fr)"]}
        flexDirection={"column"}
        gridGap={20}
      >
        <Box style={{ gridColumn: "1 / -1" }}>
          <Title
            title={"Quality Improvement"}
            onClick={() => {
              navigate("/");
            }}
          />
          <NavigationTabs tabs={QiTabs} />
        </Box>
        <Grid
          h={"100%"}
          templateColumns={[
            "repeat(1, 1fr)",
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
            "repeat(4, 1fr)",
          ]}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
          gap={[4, 4, 5, 5, 10, 20]}
        >
          {Menu.map((item) => (
            <NavCard
              icon={item.icon}
              title={item.title}
              onClick={item.onClick}
            />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default QIProject;
